import { useTheme } from '@mui/material/styles';

// TableSkeleton Component
const TableSkeleton = ({
  rows = 5,
  columns = 4,
  animation = 'wave',
  variant = 'text',
  height = 20,
  sx = {}
}) => {
  const theme = useTheme();
  
  const skeletonClass = animation === 'wave' ? 'animate-pulse' : animation === 'pulse' ? 'animate-bounce' : '';
  
  const SkeletonElement = ({ variant, height, sx }) => {
    const baseClasses = `${skeletonClass}`;
    const variantClasses = {
      text: 'rounded',
      rectangular: 'rounded-sm',
      circular: 'rounded-full'
    };
    
    // Use MUI theme colors for skeleton background
    const skeletonStyles = {
      backgroundColor: theme.palette.mode === 'dark' 
        ? theme.palette.grey[700] 
        : theme.palette.grey[300],
      height: `${height}px`,
      ...sx
    };
    
    return (
      <div 
        className={`${baseClasses} ${variantClasses[variant] || variantClasses.text}`}
        style={skeletonStyles}
      />
    );
  };

  const tableContainerStyles = {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    ...sx
  };

  const tableCellStyles = {
    borderBottom: `1px solid ${theme.palette.divider}`,
    padding: theme.spacing(2)
  };

  return (
    <div style={tableContainerStyles} className="overflow-hidden">
      <table className="w-full">
        <tbody>
          {[...Array(rows)].map((_, rowIndex) => (
            <tr key={rowIndex}>
              {[...Array(columns)].map((_, colIndex) => (
                <td key={colIndex} style={tableCellStyles}>
                  {colIndex === 0 ? (
                    // First column - User info with avatar and text
                    <div className="flex items-center space-x-3">
                      <SkeletonElement 
                        variant="circular" 
                        height={40} 
                        sx={{ width: 40 }}
                      />
                      <div className="space-y-2">
                        <SkeletonElement 
                          variant="text" 
                          height={16} 
                          sx={{ width: 120 }}
                        />
                        <SkeletonElement 
                          variant="text" 
                          height={12} 
                          sx={{ width: 80 }}
                        />
                      </div>
                    </div>
                  ) : colIndex === 2 ? (
                    // Sessions column - badge style
                    <SkeletonElement 
                      variant="rectangular" 
                      height={24} 
                      sx={{ 
                        width: 60,
                        borderRadius: theme.shape.borderRadius * 2
                      }}
                    />
                  ) : colIndex === 4 ? (
                    // Details column - icon style
                    <SkeletonElement 
                      variant="circular" 
                      height={24} 
                      sx={{ width: 24 }}
                    />
                  ) : (
                    // Regular text columns
                    <SkeletonElement 
                      variant={variant} 
                      height={height}
                      sx={{ width: '80%' }}
                    />
                  )}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TableSkeleton;